/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "components/ui/button";
import { MoreVerticalIcon } from "lucide-react";
import { StatusEnum } from "../../../../enum/status";
import { cn } from "../../../../lib/utils";
import DropdownMenuComponent from "../components/action-table";
import { format } from "date-fns";
import SortedCell from "../components/sorted-cell";

const muthedRow = (status: StatusEnum) => {
  return cn("w-full h-full px-[10px] py-[6px]", {
    "bg-[#F0F0F1]": status === StatusEnum.INACTIVE,
  });
};

export const columns = [
  {
    accessorKey: "name",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"name"} column={column} title={"Nome"} />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`${muthedRow(row?.original?.status)}`}>
          {row?.original?.name}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "created_at",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"created_at"} column={column} title={"Criado em"} />
    ),
    cell: ({ row }: { row: any }) => {
      const formattedDate = format(
        new Date(row?.original?.created_at),
        "dd/MM/yyyy"
      );
      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {formattedDate}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    accessorKey: "updated_at",
    header: ({ column }: { column: any }) => (
      <SortedCell key={"updated_at"} column={column} title={"Atualizado em"} />
    ),
    cell: ({ row }: { row: any }) => {
      const formattedDate = format(
        new Date(row?.original?.updated_at),
        "dd/MM/yyyy"
      );

      return (
        <div
          className={`flex justify-start ${muthedRow(row?.original?.status)}`}
        >
          {row?.original?.updated_at ? formattedDate : "--"}
        </div>
      );
    },
    className: "!p-0",
  },
  {
    id: "actions",
    header: () => <div> Ações </div>,
    cell: ({ row }: { row: any }) => {
      return (
        <div
          className={`w-full flex items-center justify-center ${muthedRow(
            row?.original?.status
          )}`}
        >
          <DropdownMenuComponent
            row={row?.original}
            trigger={
              <Button
                variant="link"
                className="p-0 m-0 h-[0px] flex items-center justify-center"
              >
                <MoreVerticalIcon className="w-[20px]" />
              </Button>
            }
          />
        </div>
      );
    },
    className: "!p-0 w-[50px] items-center justify-center",
  },
];
